import { useNavigate } from 'react-router'
import { Logger } from '@egw/logger'
import { WEALTH_ROUTES } from '@egw/constants'
import { ROUTES } from '../../../constants/routes/routes-generic'

const log = new Logger('Enrollment - Error Handler')

export const useHandleEnrollmentErrors = (contextName = 'enrollment') => {
  const navigate = useNavigate()

  return (response: { isError?: boolean; errors?: string[] } | undefined | null): boolean => {
    if (!response || !response.isError || !response.errors?.length) {
      return false
    }

    const errors = response.errors
    log.error(`${contextName} submission errors:`, errors)

    if (errors.includes('APPLICATION_ABANDONED')) {
      log.info('Application abandoned, redirecting to timed out page')
      void navigate(`${WEALTH_ROUTES.ENROLLMENT.path}/${ROUTES.TIMED_OUT.path}`)
      return true
    }

    return false
  }
}
